import CartIcon from "./CartIcon";

export default CartIcon;